import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, importProvidersFrom, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { appRoutes } from './app.routes';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { Auth0ConfigFactory, auth0TokenInterceptor, AuthConfiguration } from '@lib/auth/data-access';
import { datetimeInterceptor, EnvironmentService, ErrorHandlerService, problemInterceptor } from '@lib/shared/data-access';
import { AuthClientConfig, provideAuth0 } from '@auth0/auth0-angular';
import { provideServiceWorker } from '@angular/service-worker';
import { DialogService } from 'primeng/dynamicdialog';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
// import Nora from '@primeuix/themes/nora';
import { environment } from '../environments/environment';
import { APP_ENVIRONMENT } from '@lib/shared/models';
import { tenantInterceptor } from '@lib/tenant/data-access';



export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      })
    ),
    provideHttpClient(
      withInterceptors([datetimeInterceptor, tenantInterceptor, auth0TokenInterceptor, problemInterceptor]),
      withInterceptorsFromDi(),
      withFetch()),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: Aura,
        options: {
          cssLayer: {
            name: 'primeng',
            order: 'properties,theme,base,components,primeng,utilities'
          },
          darkModeSelector: '.app-dark',
        },
      },
    }),
    {
      provide: APP_ENVIRONMENT,
      useValue: environment,
    },
    //Auth0
    provideAuth0(), //Bootstrapping Auth0
    {
      provide: APP_INITIALIZER,
      useFactory: Auth0ConfigFactory,
      deps: [AuthConfiguration, AuthClientConfig],
      multi: true
    },
    AuthConfiguration,
    EnvironmentService,
    MessageService,
    DialogService,
    ConfirmationService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom([
      BrowserModule,
      BrowserAnimationsModule
    ]),
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerService
    },
    provideServiceWorker('ngsw-worker.js',
      {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
      })
  ],
};
